var GroupInquiry = {
    setGroupInquiry : function(checkbox, value) {
        $(checkbox).prop('checked', value);

        if (! value) {
            $(checkbox).parent().children('.jq-checkbox').removeClass('checked')
        }
    },
    refreshHeader: function(content) {
        $('.header-viewed-g .viewed-drop-g-a').html(content);
        $('.group-bottom-content').html(content)
        if ($(".footer-compare-group-panel .viewed-item").length == 0) {
            $(".footer-compare-group-panel").removeClass("open")
        } else {
            $(".footer-compare-group-panel").addClass("open")
            $(".group-footer-btn").click()
        }
    }
};
$(window).on("load", function() {
    $('.group-inquiry-checkbox').each(function() {
        if ($(this).prop('checked')) {
            $(this).next("span.jq-checkbox").next("label").attr("title", "Usuń z zapytania grupowego")
        } else {
            $(this).next("span.jq-checkbox").next("label").attr("title", "Dodaj do zapytania grupowego")
        }
    })
})

$(document).ready(function() {
    $('.group-inquiry-checkbox').change(function() {
        var checkbox = $(this);
        if ($(this).prop('checked')) {
            checkbox.next("span.jq-checkbox").next("label").attr("title", "Usuń z zapytania grupowego")
            $.ajax({
                'url' : checkbox.data('href'),
                'method' : 'POST',
                'data' : {'object-slug' : checkbox.val()},
                success: function(response) {
                    if (response.status == 'max') {
                        swal({
                            title : '',
                            text : 'Możesz dodać maksymalnie ' + response.max+ ' obiekty.',
                            type : 'error',
                            confirmButtonColor: '#97762c',
                        });
                        GroupInquiry.setGroupInquiry(checkbox, false);
                    } else if (response.status == 'ok') {
                        GroupInquiry.setGroupInquiry(checkbox, true);
                        GroupInquiry.refreshHeader(response.content);
                        $.notify("Obiekt został dodany do grupowego zapytania", "success");
                        $(".group-inquiry-checkbox").each(function() {
                            if ($(this).val() == checkbox.val()) {
                                $(this).attr('checked', true)
                                $(this).next("span.jq-checkbox").addClass("checked")
                                $(this).next("span.jq-checkbox").next("label").attr("title", "Usuń z zapytania grupowego")
                            }
                        })
                    }
                }
            });
            
        } else {
            checkbox.next("span.jq-checkbox").next("label").attr("title", "Dodaj do zapytania grupowego")
            $.ajax({
                'url' : checkbox.data('href-remove'),
                'method' : 'DELETE',
                success: function (response) {
                    if (response.status == 'ok') {
                        GroupInquiry.setGroupInquiry(checkbox, false);
                        GroupInquiry.refreshHeader(response.content);

                        if ($('#grupowe-zapytanie').length) {
                            checkbox.parents('.offer-slider-i').first().fadeOut(function() {
                                $(this).remove();
                                if ($('#grupowe-zapytanie > .offer-slider-i').length == 0) window.location.reload(false);
                            });
                        }
                    }
                }
            });
        }
    });
});
function deletegroupinquiry(obj) {
    var link = $(obj);
    var obj = link.attr('data-value');
    $(".group-inquiry-checkbox").each(function() {
        if ($(this).val() == obj) {
            $(this).attr("checked", false)
            $(this).next("span.jq-checkbox").removeClass("checked")
            $(this).next("span.jq-checkbox").next("label").attr("title", "Dodaj do zapytania grupowego")
        }
    })
    $.ajax({
        'url' : link.data('href-remove'),
        'method' : 'DELETE',
        success: function (response) {
            if (response.status == 'ok') {
                GroupInquiry.setGroupInquiry(link, false);
                GroupInquiry.refreshHeader(response.content);
            }
        }
    });
};